import {mutationTypes} from '@/core/constants'

export default {

    [mutationTypes.ORCAMENTO.SET_FILTROS_BUSCA_TODOS_ORCAMENTOS](state, filtros) {
        state.resultadoBuscaTodosOrcamentosFicha.filtros = filtros
    },

    [mutationTypes.ORCAMENTO.SET_PAGINACAO_BUSCA_TODOS_ORCAMENTOS](state, paginacao) {
        state.resultadoBuscaTodosOrcamentosFicha.paginacao = paginacao
    },

    [mutationTypes.ORCAMENTO.RESETA_PAGE](state) {
        state.resultadoBuscaTodosOrcamentosFicha.paginacao.page = 1
    }

}